export default {
  black: '#000',
  white: '#fff',

  // Slate
  slate50: '#f8fafc',
  slate100: '#f1f5f9',
  slate200: '#e2e8f0',
  slate300: '#cbd5e1',
  slate400: '#94a3b8',
  slate500: '#64748b',
  slate600: '#475569',
  slate700: '#334155',
  slate800: '#1e293b',
  slate900: '#0f172a',

  // Indigo
  indigo50: '#eef2ff',
  indigo100: '#e0e7ff',
  indigo400: '#818cf8',
  indigo600: '#4f46e5',
  indigo700: '#4338ca',

  // Emerald
  emerald50: '#ecfdf5',
  emerald100: '#d1fae5',
  emerald600: '#059669',
  emerald700: '#047857',

  // Amber
  amber100: '#fef3c7',
  amber700: '#b45309',

  // Rose
  rose50: '#fff1f2',
  rose600: '#e11d48'
}
